module.exports = __webpack_public_path__ + "img/barvy.86de568c.webp";